import { useEffect } from "react";
import { useQuery } from "@apollo/client/react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { getFilterItems, getTagFilterItems } from "./sidebar.graphql";
import { useSidebarContext, ACTIONS } from "./context";

const useSidebarDataQuery = (filters, shouldGetFilters) => {
  const { peopleTagTypesFilter } = useWorkspaceFeatureFlags();

  const [
    {
      query: { isLoaded, variables },
    },
    dispatch,
  ] = useSidebarContext();

  const { searchTermsKey } = variables;
  const isSearching = isLoaded && !!searchTermsKey;
  const isSearchingPersonTags = searchTermsKey === "personTags";

  const { personTags, personTagTypes, ...otherFilters } = filters;

  const { data: filterData, error: filterError } = useQuery(getFilterItems, {
    variables: {
      ...variables,
      filter: otherFilters,
    },
    fetchPolicy: "cache-first",
    skip: !shouldGetFilters || (isSearching && isSearchingPersonTags),
  });

  const { data: tagFilterData, error: tagFilterError } = useQuery(
    getTagFilterItems,
    {
      variables: {
        ...variables,
        filter: { personTags, personTagTypes },
      },
      fetchPolicy: "cache-first",
      skip:
        !peopleTagTypesFilter ||
        !shouldGetFilters ||
        (isSearching && !isSearchingPersonTags),
    }
  );

  useEffect(() => {
    if (!filterData) return;
    dispatch({
      type: ACTIONS.QUERY_COMPLETE,
      data: filterData,
    });
  }, [dispatch, filterData]);

  useEffect(() => {
    if (!filterError) return;
    dispatch({ type: ACTIONS.QUERY_ERROR, error: filterError });
  }, [dispatch, filterError]);

  useEffect(() => {
    if (!tagFilterData) return;
    dispatch({
      type: ACTIONS.TAGS_QUERY_COMPLETE,
      data: tagFilterData,
    });
  }, [dispatch, tagFilterData]);

  useEffect(() => {
    if (!tagFilterError) return;
    dispatch({ type: ACTIONS.QUERY_ERROR, error: tagFilterError });
  }, [dispatch, tagFilterError]);

  return null;
};

export default useSidebarDataQuery;
